import { call, put, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import { profileApi, updateProfileApi, verifyProfileOtpApi } from "services/ProfileService";
import {
  GET_PROFILE_FAILED,
  GET_PROFILE_REQUESTED,
  GET_PROFILE_SUCCESS,
  GET_UPDATEPROFILE_FAILED,
  GET_UPDATEPROFILE_REQUESTED,
  GET_UPDATEPROFILE_SUCCESS,
  GET_VERIFY_PROFILE_FAILED,
  GET_VERIFY_PROFILE_REQUESTED,
  GET_VERIFY_PROFILE_SUCCESS,
} from "resources/actionTypes";
import store from "redux/store";
import { getProfile } from "redux/actions/UserProfile";
import { onLoaderTrigger } from "redux/actions/CommonAction";

function* fetchProfile(action) {    
   try{
    const userProfile = yield call(profileApi);
		yield put({ type: GET_PROFILE_SUCCESS, userProfile: userProfile });
		if(userProfile?.success){
     localStorage.setItem('status',userProfile?.data?.status)
     localStorage.setItem('firstName',userProfile?.data?.firstName)
     localStorage.setItem('lastName',userProfile?.data?.lastName)
     localStorage.setItem('email',userProfile?.data?.email)
     localStorage.setItem('mobile',userProfile?.data?.mobile)
		 localStorage.setItem('customer',userProfile?.data?.DemandProfile ? true : false)
		if(action?.payload?.tabType === 'auth'){ 
      store.dispatch(onLoaderTrigger(false));
      const type = localStorage.getItem('type')
      if(type && type !== null && type !== 'null'){
        window.location.replace('/home?type='+type);
      }else{
        window.location.replace('/home');
        
      }
    }
	}
   }
  catch (e) {
    yield put({ type: GET_PROFILE_FAILED, message: e?.message });
    store.dispatch(onLoaderTrigger(false));
	}
  }

export function* ProfileSaga() {
  yield takeEvery(GET_PROFILE_REQUESTED, fetchProfile);
}

function* fetchUpdateProfile(action) {
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const userUpdateProfile = yield call(
    updateProfileApi,
    payload.userUpdateProfile
  );
  if (userUpdateProfile?.success) {
    yield put({
      type: GET_UPDATEPROFILE_SUCCESS,
      userUpdateProfile: userUpdateProfile,
    });
    toast.success(userUpdateProfile?.message || 'Update Profile Number Successfully');
    store.dispatch(onLoaderTrigger(false));
    if(userUpdateProfile?.data[0]?.otpSecret){
      localStorage.setItem('verifySecretToken',userUpdateProfile?.data[0]?.otpSecret)
      payload.setConfirmModal !== "Resend" && payload.setConfirmModal();
    }else{
    store.dispatch(getProfile())
    }
   

  } else {
    yield put({
      type: GET_UPDATEPROFILE_FAILED,
      message: userUpdateProfile?.message,
    });
      toast.error(userUpdateProfile?.message || "Update Profile Failed");
    store.dispatch(onLoaderTrigger(false));
  }
}
export function* updateProfileSaga() {
	yield takeEvery(GET_UPDATEPROFILE_REQUESTED, fetchUpdateProfile);
}

function* fetchVerifyProfile(action){
  const payload = action.payload || {};
  store.dispatch(onLoaderTrigger(true));
  const userVerifyProfile = yield call(verifyProfileOtpApi, payload.userVerifyProfile);
  if(userVerifyProfile?.success){
    yield put({
      type: GET_VERIFY_PROFILE_SUCCESS,
      userVerifyProfile:userVerifyProfile,
    });
    payload.setCloseModal !== 'Resend' && payload.setCloseModal();
    toast.success(userVerifyProfile?.message || 'Customer details verified Successfully')
    store.dispatch(onLoaderTrigger(false));
    store.dispatch(getProfile())
  }
    else{
      yield put({
        type: GET_VERIFY_PROFILE_FAILED,
        message: userVerifyProfile?.message,
      });
      toast.error(userVerifyProfile?.message || "OTP verification failed")
      store.dispatch(onLoaderTrigger(false));
    }
  }
  export function* verifyProfileSaga(){
    yield takeEvery(GET_VERIFY_PROFILE_REQUESTED, fetchVerifyProfile);
}
